module.exports = __webpack_public_path__ + "img/sixthfeatureicon.36a0708e.webp";